module.exports = __webpack_public_path__ + "static/media/kettle.13c5d212.png";